<template>
  <div class="container">
    <app-header title="上传报价单"/>
    <div class="tab">
      <div class="item" v-for="(item,index) in tabList" :key="item.id" @click="onTagClick(index)">
        <img :src="item.image" alt="电子元器件需求" width="50" height="50">
        <span :class="[index==active?'active':'']">{{item.name}}</span>
      </div>
    </div>

    <div class="main">
      <img src="@/assets/upload01.png" alt="上传" width="186" height="123" @click="show = true">
      <div class="title">上传报价单文件/图片</div>
      <div class="tip">是否包含13%增值税</div>
      <div class="money">
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="1" checked-color="#FE003B">是</van-radio>
          <van-radio name="0" checked-color="#FE003B">否</van-radio>
        </van-radio-group>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }" >
      <div class="popup">
        <div class="item" @click="onNavigate('/business/price/file')">
          <img src="@/assets/file.png" alt="文件" width="25" height="25">
          <span class="name">文件</span>
        </div>
        <div class="item" @click="onNavigate('/business/price/image')">
          <img src="@/assets/image.png" alt="图片" width="25" height="25">
          <span class="name">图片</span>
        </div>
        <div class="item" @click="onNavigate('/businessTb')">
          <img src="@/assets/table.png" alt="图片" width="25" height="25">
          <span class="name">逐个填写</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "add",
    data(){
      return{
        show: false,
        active: 0,
        radio: '1',
        tabList: [
          { id: 0, name: '电子元器件报价', image: require('@/assets/purchase01.png') },
          { id: 1, name: '产品报价', image: require('@/assets/purchase02.png') },
          { id: 2, name: '其他报价', image: require('@/assets/purchase03.png') }
        ],
      }
    },
    methods:{
      onTagClick(index) {
        this.active = index
      },
      onNavigate(url) {
        this.$router.push({
          path: url,
          query: { type: this.active,
          inclusive : this.radio
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .container{
    .tab{
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      padding: 8px 0;
      .item{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span{
          margin-top: 5px;
          height:20px;
          font-size:14px;
          font-weight:400;
          line-height:21px;
          color:rgba(102,102,102,1);
        }
        .active{
          color:rgba(254,0,59,1);
        }
      }
    }

    .main{
      height: 500px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        height:22px;
        font-size:16px;
        font-weight:bold;
        line-height:22px;
        color:rgba(102,102,102,1);
      }
      .tip{
        height:18px;
        font-size:13px;
        font-weight:400;
        line-height:18px;
        color:rgba(254,0,59,1);
        margin-top: 21px;
      }
      .money{
        margin-top: 8px;
      }
    }
    .popup{
      padding: 22px;
      display: inline-flex;
      .item{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 30px;
        .name{
          margin-top: 8px;
          height:18px;
          font-size:13px;
          font-weight:400;
          line-height:18px;
          color:rgba(102,102,102,1);
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/business/price/index.vue